import Form from "../../ui/Form";
import CustomerField from "./CustomerField";
import CarField from "./CarField";
import DateField from "./DateField";
import { printDate } from "../../utils/date.utils";
import {
  useCreateCustomerAttachmentMutation,
  useUpdateCustomerAttachmentMutation
} from "../../utils/customerAttachment.utils";
import { useNavigate } from "react-router-dom";
import InwordsTotalField from "./InwordsTotalField";
import { arrayMap } from "../../utils/array.utils";

export default function QuotationForm({ title, defaultValues, onBack, existCustomer }) {
  const navigate = useNavigate();

  const id = defaultValues?.id ?? null;

  let fields = [
    {
      name: "dateField",
      type: "custom",
      customComponent: DateField,
      col: { md: 12 }
    },
    {
      name: "customerField",
      type: "custom",
      customComponent: CustomerField,
      col: { md: 12 }
    }
  ];

  // conditionally car field handle for single and multiple
  if (defaultValues?.isMultiQuot) {
    defaultValues?.multiCars?.forEach((item, index) => {
      fields.push({
        name: `carField_${index}`,
        type: "custom",
        customComponent: CarField,
        col: { md: 12 },
        others: { sl: index, car: item, isMulti: defaultValues?.isMultiQuot }
      });
    });
  } else {
    fields.push({
      name: "carField",
      type: "custom",
      customComponent: CarField,
      col: { md: 12 }
    });
  }

  // price field
  fields.push({
    name: "inwordsTotalField",
    type: "custom",
    customComponent: InwordsTotalField,
    col: { md: 12 }
  });

  // create attachement mutation
  const { loading, createCustomerAttachment } = useCreateCustomerAttachmentMutation([
    "createCustomerAttachment"
  ]);

  const { loading: updating, updateCustomerAttachment } = useUpdateCustomerAttachmentMutation([
    "updateCustomerAttachment"
  ]);

  // after create or update the page will redirect to quotation list or customer quotation list
  function handleRedirect() {
    if (existCustomer?.profile?.customer_id) {
      navigate(`/customer/${existCustomer.profile.customer_id}/view?tab=1`);
    } else {
      navigate("/quotation-list");
    }
  }

  const onSubmit = async (values) => {
    const qoutDate = printDate(values.qoutDate);
    const validUntil = printDate(values.validUntil);
    const formattedData = { ...values, qoutDate, validUntil };
    const strigifyData = JSON.stringify(formattedData);

    const { multiCars, isMultiQuot } = formattedData;

    let createData = {
      type_id: 1,
      attachment: strigifyData,
      customer_id: values?.customer?.customer_id ?? "",
      is_multi: isMultiQuot
    };

    if (isMultiQuot && multiCars?.length) {
      createData.stock_list_ids =
        arrayMap(multiCars, (item) => item.id ?? item?.stock_list_id) || [];
    } else {
      createData.stock_list_ids = values?.car?.stock_list_id ? [values?.car?.stock_list_id] : [];
    }

    // update
    if (!!id) {
      const afterUpdated = await updateCustomerAttachment({ id, ...createData });

      if (afterUpdated?.status === 200) {
        handleRedirect();
      }
      return;
    }

    // create
    const afterCreated = await createCustomerAttachment({ ...createData });

    if (afterCreated?.status === 201) {
      handleRedirect();
    }
  };

  const isLoading = loading || updating;

  return (
    <Form
      fields={fields}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      submitbtnText={isLoading ? `${!!id ? "Editing..." : "Adding...."}` : title}
      loading={typeof isLoading === "boolean" ? isLoading : undefined}
      closebtnText={"Back"}
      onClose={onBack}
    />
  );
}
